import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContentBlockComponent } from '../content-block/content-block.component';
import { VideoComponent } from './components/video/video.component';

@Component({
    selector: 'nw-video-block',
    imports: [ContentBlockComponent, VideoComponent],
    templateUrl: './video-block.component.html',
    styleUrl: './video-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoBlockComponent {
    @Input() videourl?: string;
    @Input() thumbnail?: string;
    @Input() videoalternativetext?: string;
    @Input() videoduration?: string;
}
